import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import PageBase from 'components/common/PageBase';
import SearchPage from 'containers/search/SearchPage';

class ICNPlusPage extends Component {
    render() {
        const { translate} = this.props;
        return (
            <PageBase title={translate('ICNPlusForm.title')} showGoToButtons={false}>
                <SearchPage linkGoToDetails={"accidentreconstruction/details/"} showSingleExport={true}  isIcnPlus={true} isDent={false}  />
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}

export default connect(mapStateToProps)(ICNPlusPage);


// WEBPACK FOOTER //
// ./src/pages/icnplus/ICNPlusPage.js